<template>
	<section class="container container--small module-margin">
		<div class="inner">
			<h2 v-if="data.module_title" class="titler module-title margin-bottom-md">{{ data.module_title }}</h2>
			<div v-if="data.links" class="links-list">
				<template v-for="({ link, file, type }, k) in data.links">
					<Button
						block
						:theme="btnTheme"
						:class="linkType(link.url)"
						v-if="link && type === 'link'"
						:key="k"
						:acf-link="link"
						icon="arrowRight"
					/>
					<Button
						block
						:theme="btnTheme"
						class="download"
						target="_blank"
						v-if="file && file.url && type === 'attachment'"
						:key="k"
						:href="file.url"
						download
						icon="download"
					>
						Download: {{ file.filename }}
					</Button>
				</template>
			</div>
		</div>
	</section>
</template>

<script>
import Button from '@/components/elements/Button'
import { isExternal } from '@/helpers'
import { mapGetters } from 'vuex'

export default {
	name: 'link-buttons',
	props: ['data'],
	computed: {
		...mapGetters(['pageTheme']),
		btnTheme() {
			return this.pageTheme && this.pageTheme !== 'default' ? this.pageTheme : 'dark'
		},
	},
	methods: {
		linkType(link) {
			const home = window.WPVUE.home
			return !isExternal(link, home) ? 'internal' : 'external'
		},
	},
	components: {
		Button,
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.module-links {
	.links-list {
		.button {
			margin-bottom: 15px;
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
}
</style>
